import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "detailed-audio-player" }
const _hoisted_2 = { class: "detailed-audio-player__title" }
const _hoisted_3 = { class: "detailed-audio-player__controller" }
const _hoisted_4 = { class: "detailed-audio-player__button" }

import AudioController from "@/components/UI/AudioPlayer/AudioController.vue";
import Icon from "@/components/UI/Icon.vue";
import BackgroundAudio, {PlayerMetadata} from "@/ts/Audio/BackgroundAudio";
import {computed, onMounted, onUnmounted, ref, watch} from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'DetailedAudioPlayer',
  props: {
    image: {},
    title: {},
    audio: {},
    type: {},
    id: {},
    theme: { default: 'light' }
  },
  setup(__props: any) {


const props = __props;
const backgroundAudio = BackgroundAudio.getInstance();
const {isPlaying, playerMetadata} = backgroundAudio;
const hasNext = ref(false);
const hasPrevious = ref(false);

watch(playerMetadata, () => {
  hasNext.value = backgroundAudio.hasNext();
  hasPrevious.value = backgroundAudio.hasPrevious();
}, { immediate: true });
const onClick = () => {
  isPlaying.value ? backgroundAudio.pause() : backgroundAudio.play();
}
const onEnded = () => {
  backgroundAudio.pause()
}
onMounted(() => {
  backgroundAudio.addEventListener('ended', onEnded);
});
onUnmounted(() => {
  backgroundAudio.removeEventListener('ended', onEnded);
});
const buttonColor = computed(() => props.theme === 'light' ? '#6C7BB2' : '#FFFFFF');
const onPrev = () => {
  if (!backgroundAudio.hasPrevious()) return
  backgroundAudio.playPrevious();
}
const onNext = () => {
  if (!backgroundAudio.hasNext()) return
  backgroundAudio.playNext();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(AudioController, { audio: _ctx.audio }, null, 8, ["audio"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(Icon, {
        class: _normalizeClass({locked: !hasPrevious.value}),
        size: 24,
        color: buttonColor.value,
        name: "play-next",
        onClick: onPrev
      }, null, 8, ["class", "color"]),
      _createElementVNode("div", {
        class: _normalizeClass(["detailed-audio-player__button__action", {play: _unref(isPlaying)}]),
        onClick: onClick
      }, null, 2),
      _createVNode(Icon, {
        class: _normalizeClass({locked: !hasNext.value}),
        size: 24,
        color: buttonColor.value,
        name: "play-next",
        rotate: 180,
        onClick: onNext
      }, null, 8, ["class", "color"])
    ])
  ]))
}
}

})